import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
import { FormService } from './form.service';

@Injectable({
    providedIn: 'root',
  })
  export class ProgressStepperDataService {
    samePerson: string = '';
    errorMessage : string

    
     routes  = [
        {
           path: `/start`,
          data: { stepIndex: 0, progress: 0.25}},
        {
          path: `/object-details`,
          data: {stepIndex: 0, progress: 0.5},
        },
        {
          path: `/object-details-2`,
          data: {stepIndex: 0, progress: 0.75},
        },
        { path: `/package-selection`,
          data: {stepIndex: 1, progress: 0.5}
        },
        { path: `/object-additional-details`,
        data: { stepIndex: 2, progress: 0.25}
        },
        { path: `/contact-details`,
          data: { stepIndex: 2, progress: 0.5}
        },
        { path: `/contact-details-2`,
          data: { stepIndex: 2, progress: 0.75}
         },
        { path: `/summary`,
          data: { stepIndex: 3, progress: 0}
         },
         { path: `/consents`,
         data: {stepIndex: 3, progress: 0.5}
        },
        { path: `/home/somethingWentWrong`,
        data: {stepIndex: 3, progress: 0.25}
        },
        { path: `purchase`,
          data: null
         }
      ];

    constructor(private router: Router, private sharedService: SharedService, private formService: FormService) {}
    getProgressStepper() {
        let url =  window.location.pathname;
        let data;
        this.routes.filter(x => {
             if((url == x.path)) {
                data = x.data
             }
         });
         console.log(data)
         return data;
         
     }

     stepClick($event) {
        if ($event == 1) {
          this.router.navigate(['start']);
        }
        if ($event == 2) {
          this.router.navigate(['package-selection']);
        }
        if ($event == 3) {
          this.router.navigate(['object-additional-details']);
        }
        if ($event == 4) {
          this.router.navigate(['summary']);
        }
      }

      goBackClick() { 

        if(this.formService.currentForm.controls.samePerson.value === 'Y') {
            this.samePerson ='Y';
        }
              
        let url =  window.location.pathname;
        let afterLastSlash = url.substring((url.lastIndexOf('/')) + 1);
        let index = this.routes.findIndex((e) => ('/'+afterLastSlash == e.path));
         if (this.samePerson === 'Y' && afterLastSlash.includes('summary')) {
          this.router.navigate([this.routes[index - 2].path]);
        } else if (afterLastSlash.includes('error') || afterLastSlash.includes('wrong')){
        //   if(this.errorMessage.includes('3 екран')){
            this.router.navigate(['home']); 
        //   }
        //   else{
        //     this.router.navigate([this.routes[index - 1].path]);
        //   }
        }
        else if (index !== -1) {
          this.router.navigate([this.routes[index - 1].path]);
        }
        else if(afterLastSlash.includes('payment')){
          this.router.navigate(['consents'])
        }

      }

  }
